class BackToTop extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        this.classList.remove('opacity-0');
        this.classList.add('opacity-100', 'duration-300', 'transition-opacity');
      } else {
        this.classList.remove('opacity-100');
        this.classList.add('opacity-0');
      }
    });
  }
}

customElements.define('back-to-top', BackToTop);
